import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function MessageCircleIcon(props: SvgIconProps) {
  const fill = props.fill ?? props.color ?? '#B8BABF';
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z'
        fill={fill}
      />
      <path
        d='M16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13Z'
        fill={fill}
      />
      <path
        d='M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z'
        fill={fill}
      />
      <path
        d='M19.0701 4.93051C17.4293 3.27901 15.2638 2.25172 12.9467 2.02575C10.6297 1.79978 8.30647 2.38929 6.3775 3.69264C4.44854 4.996 3.03475 6.93152 2.37988 9.16552C1.72501 11.3995 1.87009 13.792 2.79012 15.9305C2.88601 16.1293 2.91747 16.353 2.88012 16.5705L2.00012 20.8005C1.96621 20.9627 1.97314 21.1307 2.02027 21.2896C2.06739 21.4484 2.15325 21.5931 2.27012 21.7105C2.36592 21.8056 2.47999 21.8803 2.60545 21.9302C2.73091 21.98 2.86516 22.004 3.00012 22.0005H3.20012L7.48012 21.1405C7.69765 21.1144 7.91824 21.1454 8.12012 21.2305C10.2586 22.1505 12.6511 22.2956 14.8851 21.6407C17.1191 20.9859 19.0546 19.5721 20.358 17.6431C21.6613 15.7142 22.2508 13.3909 22.0249 11.0739C21.7989 8.75687 20.7716 6.5913 19.1201 4.95051L19.0701 4.93051ZM19.9001 13.2905C19.7046 14.4845 19.2408 15.6186 18.5437 16.6074C17.8465 17.5963 16.9342 18.4141 15.8753 18.9994C14.8164 19.5847 13.6385 19.9221 12.4303 19.9864C11.2222 20.0507 10.0151 19.8401 8.90012 19.3705C8.50466 19.2023 8.07985 19.1139 7.65012 19.1105C7.4624 19.1118 7.2751 19.1285 7.09012 19.1605L4.27012 19.7305L4.84012 16.9105C4.95364 16.2998 4.88046 15.669 4.63012 15.1005C4.16051 13.9855 3.94992 12.7785 4.01421 11.5703C4.0785 10.3621 4.41598 9.18426 5.00126 8.12536C5.58654 7.06646 6.40438 6.15411 7.39321 5.45696C8.38205 4.75981 9.51614 4.29603 10.7101 4.10051C11.9634 3.89483 13.2476 3.99048 14.4566 4.37957C15.6656 4.76866 16.7645 5.43999 17.6626 6.33805C18.5606 7.2361 19.232 8.33506 19.6211 9.54403C20.0101 10.753 20.1058 12.0372 19.9001 13.2905Z'
        fill={fill}
      />
    </SvgIcon>
  );
}
